import React, { useState, useEffect } from "react";
import Header from "../../components/header1/Header1";
import Footer from "../../components/footer/Footer";
import bannerImage from "../../elements/hero-banner-faqs-page.png";
import { IoIosArrowDropdown } from "react-icons/io";
import { fetchLearningTracks } from "../../services/studentportalapis";
import { useParams } from "react-router-dom";

const KnowMore = ({ trackId,trackName, onClose }) => {
  const [openAccordion, setOpenAccordion] = useState(null); 
  const [openDetails, setOpenDetails] = useState(null);
  const [courseDetails, setCourseDetails] = useState([]);
  const [file, setFile] = useState(null);
  const [trackDetails, setTrackDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  

   

  useEffect(() => {
    const fetchTrackDetails = async () => {
    fetchLearningTracks(trackId)
      .then((data) => {
        setCourseDetails(data);
        console.log("Data is:", data);
        console.log("trackname is:",trackName)
        console.log("id is:", trackId);

      })
      .catch((err) => console.error("Error fetching student tracks:", err))
      .finally(() => { // Use a function here
        setIsLoading(false);
    });
    }
    fetchTrackDetails();
  }, [trackId]);

  if (isLoading) {
    return (
        <div className="p-4">
            <p>Loading...</p>
        </div>
    );
}


 

  const toggleAccordion = (accordionId) => {
    setOpenAccordion(openAccordion === accordionId ? null : accordionId);
  };

 
  const handleToggleDetails = (index) => {
    setOpenDetails(openDetails === index ? null : index);
  };

  const renderedCourses = new Set();

  return (
    <div className="mx-4 ">
      
      
      <div className="text-center">
        <div className="faq-content  mx-auto">
         
          {/* <div className="flex flex-col">
            <h1 className="text-3xl font-bold">Learning Track</h1>
            <p className="text-2xl text-gray-500 mb-4">{trackName}</p>
          </div> */}
          
            <div className="flex items-center justify-between px-2 rounded-t-lg">
              <div className="text-2xl font-bold text-center ">
              {trackName} Learning Track
              </div>
              <button
                onClick={onClose}
                className="bg-transparent text-black text-2xl"
              >
                &times;
              </button>
              </div>
              
            

          <div className="  mx-auto">
            
            <div className="mt-4">
             
                <div className="mb-4">
                  {courseDetails.map((track) => (
                    <div key={track.trackId}>
                      {track.trackId == trackId &&
                        track.sections.map((section, secIndex) => (
                          <div key={secIndex} className="mb-4">
                            <button
                              className="w-full flex items-center justify-between font-bold text-2xl px-4 py-2 bg-blue-900 rounded-md"
                              onClick={() => toggleAccordion(secIndex)}
                            >
                              {/* Button Text */}
                              <span>{section.sectionName}</span>

                             
                            </button>

                            {openAccordion === secIndex && (
                              <div className="items-left">
                                {section.courseGroups.map(
                                  (group, groupIndex) => (
                                    <div key={groupIndex} className="mb-4 py-2">
                                      <div>
                                        <p className="text-left text-blue-900 text-sm mb-2 pt-2">
                                          {group.groupName}
                                        </p>
                                        <p className="text-left font-normal text-gray-700 text-sm mb-4 leading-4">
                                          {group.groupDescription}
                                        </p>
                                      </div>
                                      <ul className="flex flex-col mt-2">
                                        {group.courses.map((course, k) => {
                                          if (
                                            !renderedCourses.has(course.poolId)
                                          ) {
                                            renderedCourses.add(course.poolId);

                                            const groupedCourses =
                                              group.courses.filter(
                                                (c) =>
                                                  c.poolId === course.poolId
                                              );
                                            const hasBorder =
                                              groupedCourses.length > 1
                                                ? "bg-gray-100 border-2 rounded-lg border-gray-500 px-3"
                                                : "border-b-2 px-4";

                                            return (
                                              <div
                                                key={k}
                                                className={`${hasBorder} border-gray-300`}
                                              >
                                                {groupedCourses.length > 1 && (
                                                  <div className="flex justify-between">
                                                    <p className="text-left text-sky-500  p-0 mt-2 mb-0 inline-block text-sm">
                                                      Choose any one
                                                    </p>
                                                    <p className="text-right bg-gray-200 border-1 border-gray-900 text-gray-900 text-xs font-semibold rounded-md px-4 py-1 mt-2 mb-0 inline-block">
                                                      Level - {group.levelName}
                                                    </p>
                                                  </div>
                                                )}
                                                {groupedCourses.map(
                                                  (groupedCourse, idx) => (
                                                    <li
                                                      key={idx}
                                                      className="w-full flex flex-col justify-between text-left font-semibold text-gray-700 text-sm py-3 border-b-2 border-gray-300 last:border-b-0"
                                                    >
                                                      <div className="w-full flex flex-col justify-between">
                                                        <div className="w-full flex justify-between space-x-6">
                                                          <div className="flex-1">
                                                            <p className="flex mb-0 px-0 text-left">
                                                              {
                                                                groupedCourse.courseName
                                                              }
                                                            </p>
                                                            <span className="text-gray-700 text-xs">
                                                              {
                                                                groupedCourse.numberOfModules
                                                              }{" "}
                                                              modules .{" "}
                                                              {
                                                                groupedCourse.durationInHours
                                                              }{" "}
                                                              hours .{" "}
                                                              {
                                                                groupedCourse.platformName
                                                              }{" "}
                                                              .{" "}
                                                              {groupedCourse.paid
                                                                ? "Paid"
                                                                : "Free"}
                                                            </span>
                                                          </div>

                                                          <div className="">
                                                            <div className="flex w-full sm:w-auto sm:flex-row flex-col space-y-0 sm:space-y-0 justify-around items-baseline">
                                                              <a
                                                                href={
                                                                  groupedCourse.courseLink
                                                                }
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="text-blue-900 text-xs hover:cursor-pointer text-center px-3 py-2"
                                                              >
                                                                {
                                                                  groupedCourse.platformName
                                                                }
                                                              </a>

                                                             

                                                              <button
                                                                onClick={() =>
                                                                  handleToggleDetails(
                                                                    groupedCourse.courseId
                                                                  )
                                                                }
                                                                className="flex flex-row text-gray-900 bg-transparent text-xs font-normal hover:underline cursor-pointer text-center py-2 items-center justify-center"
                                                              >
                                                                Details
                                                                <IoIosArrowDropdown className="ml-1 text-2xl" />
                                                              </button>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div>
                                                        {openDetails ===
                                                          groupedCourse.courseId && (
                                                          <div className="text-gray-700 mt-2 p-2 bg-gray-200">
                                                            <div className="font-semibold">
                                                              Key takeaways
                                                            </div>
                                                            <ul className="list-disc list-inside text-left text-xs mt-1 font-normal leading-4 tracking-wide ">
                                                              {course.courseDetails?.split(".")
                                                                .filter(
                                                                  (detail) =>
                                                                    detail.trim() !==
                                                                    ""
                                                                )
                                                                .map(
                                                                  (
                                                                    detail,
                                                                    index
                                                                  ) => (
                                                                    <li
                                                                      className="py-1 text-md text-gray-500"
                                                                      key={
                                                                        index
                                                                      }
                                                                    >
                                                                      {detail.trim()}
                                                                    </li>
                                                                  )
                                                                )}
                                                            </ul>
                                                          </div>
                                                        )}
                                                      </div>
                                                    </li>
                                                  )
                                                )}
                                              </div>
                                            );
                                          }
                                        })}
                                      </ul>
                                    </div>
                                  )
                                )}
                              </div>
                            )}
                          </div>
                        ))}
                    </div>
                  ))}
                  
                </div>
            

             
            </div>
            
          </div>
        </div>
        {/* <div className="flex justify-end">
        <button
                onClick={onClose}
                className="bg-gray-400 text-white px-3 py-1 mt-4 rounded-md hover:bg-red-600"
            >
                Close
            </button>
            </div> */}
      </div>
      
    </div>
  );
};

export default KnowMore;
